module.exports = __webpack_public_path__ + "img/icon_证书_C级赛事@2x.fb7cc9a9.png";